import { Barchart, CoinStack, Message, PrizeCup, Settings } from '@sravni/react-icons';

import { Image } from '@/components/Image';

import paymentImg from './imgs/payment.svg';
import rateImg from './imgs/rate.svg';
import styles from './styles.module.scss';

const br = (isMobile: boolean) => (isMobile ? '\n' : ' ');

export const getAadvantages = (isMobile: boolean) => [
  {
    id: 'rate',
    icon: <PrizeCup />,
    title: 'Высокие ставки',
    desc: 'Лучшие условия от рекламодателей',
    img: rateImg,
  },
  {
    id: 'payment',
    icon: <CoinStack />,
    title: 'Стабильные выплаты',
    desc: `Регулярные автоматизированные выплаты от 3000 ₽ на банковскую${br(isMobile)}карту / счет`,
    img: <Image className={styles['payment-img']} alt="advantages-card-img" {...paymentImg} />,
  },
  {
    id: 'tools',
    icon: <Settings />,
    title: 'Инструменты для монетизации',
    desc: 'Гибкие инструменты, легко адаптируемые под разные площадки',
  },
  {
    id: 'stats',
    icon: <Barchart />,
    title: 'Прозрачная статистика',
    desc: 'Все конверсии и доход по офферам отображаются в личном кабинете.',
  },
  {
    id: 'manager',
    icon: <Message />,
    title: 'Персональный менеджер',
    desc: 'Специализированная помощь по всем вопросам: от регистрации и подключения площадок, до настройки рекламных кампаний',
  },
];

export const getAadvantagesById = (id: string, isMobile: boolean) =>
  getAadvantages(isMobile).find((advantage) => advantage.id === id);
